import React from 'react'
import './ErrorMessage.css'

// ErrorMessageUI accepts errorList array of strings
// ErrorMessage2UI accepts errorList object from backend containing fieldName and message string
// ErrorMessage2UI should be used whenever possible
const ErrorMessageUI = ({errorList}) =>
  <React.Fragment>
    {
      errorList && errorList.length > 0 &&
      <div className='w_error_msg'>
        {
          errorList.map((error, i) =>
            <p key={i}>{error}</p>
          )
        }
      </div>
    }
  </React.Fragment>

export default ErrorMessageUI
